import request from '../../utils/request';
const querystring = require('querystring')

//获取列表数据
export const getShowNum = query => {
    query.channelCode = '46';
    var list = request({
        url: 'comState/getShowNum.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const getChartDataByGoods = query => {
    query.channelCode = '46';
    var list = request({
        url: 'comState/getChartDataByGoods.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};
export const getChartDataByMem1 = query => {
    query.channelCode = '46';
    var list = request({
        url: 'comState/getChartDataByMem1.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};
export const getChartDataByMem2 = query => {
    query.channelCode = '46';
    var list = request({
        url: 'comState/getChartDataByMem2.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const getGoodsShowNum = query => {
    query.channelCode = '46';
    var list = request({
        url: 'comOrder/getGoodsShowNum.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};